<template>
	<div class="repeat-dates">
		<div class="repeat-dates__period">
			Повторять  {{ data.repeatValue === 'monthNumber' ? 'каждый' : 'каждую'}} 
			<InputText 
				v-model="formData.period" 
				:errors="v$.formData.period.$errors" 
				:number="2" />  
			{{ data.repeatValue === 'monthNumber' ? 'месяц' : 'неделю'}}
			<template v-if="data.repeatValue === 'monthNumber'">
			<InputText 
				v-model="formData.days" 
				:errors="v$.formData.days.$errors" 
				:number="2" />  		
			числа </template>
		</div>
		<div v-if="data.repeatValue !== 'monthNumber'" class="repeat-dates__days">
			<InputRadio
				v-for="day in days"
				:key="day.value"
				:label="day.shortName"
				:checked="day.checked"
				:id="day.value"
				name="days"
				:error="Boolean(v$.formData.days.$errors.length)" 
				@update:modelValue="onDayChange($event, day.value)"
			/>
		</div>
		<template v-if="data.repeatValue !== 'monthNumber'">
			<div v-if="formData.period && formData.days >= 0" class="repeat-dates__result">
				<div class="repeat-dates__result-title">
					Что получилось:
				</div>
				<div class="repeat-dates__result-value">
					Повторять в {{ repeatDays }} {{ data.repeatValue === 'monthNumber' ? 'каждые' : 'каждую'}} {{ formData.period }} {{ data.repeatValue === 'monthNumber' ?  getNounMonth : 'неделю'}}
				</div>
			</div>
		</template>
		<template v-else>
			<div v-if="formData.period && formData.days >= 0" class="repeat-dates__result">
				<div class="repeat-dates__result-title">
					Что получилось:
				</div>
				<div class="repeat-dates__result-value">
					Повторять {{formData.days}} числа каждого {{ formData.period }} месяца
				</div>
			</div>
		</template>
	</div>	
</template>
<script>
import InputText from "@/components/base/utils/formElements/InputText.vue";
import InputRadio from "@/components/base/utils/formElements/InputRadio.vue";
import {getNoun} from "@/utils/helpers";
import useVuelidate from "@vuelidate/core";
import {helpers, minValue, required} from '@vuelidate/validators'
const {withMessage} = helpers

export default {
	name: "ScheduleRepeatDates",
	components: {
		InputText,
		InputRadio
	},
	emits: ['update:modelValue'],
	props: {
		data : {
			type: Object,
			default: () => {}
		
		},
	},
	setup() {
		return {
			v$: useVuelidate()
		}
	},

	data() {
		return {
			days: [
				{
					shortName: 'Пн',
					value: 1,
					name: 'Понедельник',
					checked: false
				}, {
					shortName: 'Вт',
					value: 2,
					name: 'Вторник',
					checked: false
				},
				{
					shortName: 'Ср',
					value: 3,
					name: 'Среда',
					checked: false
				},
				{
					shortName: 'Чт',
					value: 4,
					name: 'Четверг',
					checked: false
				},
				{
					shortName: 'Пт',
					value: 5,
					name: 'Пятница',
					checked: false
				},
				{
					shortName: 'Сб',
					value: 6,
					name: 'Суббота',
					checked: false
				},
				{
					shortName: 'Вс',
					value: 0,
					name: 'Воскресенье',
					checked: false
				}
			],
			formData: {
				period: 1,
				days: null
			},
		}
	},
	methods: {
		onDayChange(event, value) {
			this.formData.days = value
		},
		updateRepeatDates() {
			this.$emit('update:modelValue', this.formData)
		},

		fillDates(data) {
			this.formData.period = data.period
			this.formData.days = data.days
			this.days.find(item => item.value === data.days).checked = true
		}
	},
	computed: {
		repeatDays() {
			return this.days.find(item => item.value === this.formData.days)?.name
		},
		getNounMonth() {
			return getNoun(this.formData.period, 'месяц', 'месяца', 'месяцев')
		}
	},
	validations() {
		return {
			formData: {
				period: {
					required: withMessage("", required),
				},
				days: {
					required: withMessage("", required),
					minValue: withMessage("", minValue(1))
				},
			}
		}
	},

}
</script>

<style>
	
</style>
